import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const specialties = [

  { name: 'Ginecólogo', slug: 'ginecologos', active: true },
  { name: 'Urólogo', slug: 'urologos', active: true },
  { name: 'Pediatra', slug: 'pediatras', active: true },
  { name: 'Dermatólogo', slug: 'dermatologos', active: true  },
  { name: 'Traumatólogo', slug: 'traumatologos', active: true },
  { name: 'Dentista', slug: 'dentistas', active: true },
  { name: 'Otorrinolaringólogo', slug: 'otorrinolaringologos', active: true },
  { name: 'Nutriologo', slug: 'nutriologos', active: true },
  { name: 'Oftalmólogo', slug: 'oftalmologos', active: true },
  { name: 'Psiquiatra', slug: 'psiquiatras', active: true },
  { name: 'Cardiólogo', slug: 'cardiologos', active: true },
  { name: 'Endocrinólogo', slug: 'endocrinologos', active: true   },
  { name: 'Gastroenterólogo', slug: 'gastroenterologos', active: true }, 
  { name: 'Cirujano Plástico', slug: 'cirujanos-plasticos', active: true },
  { name: 'Psicólogo', slug: 'psicologos', active: true },
  { name: 'Podólogo', slug: 'podologos', active: true },
  { name: 'Acupuntor', slug: 'acupuntores', active: true },
  { name: 'Reumatologo', slug: 'reumatologos', active: true },
  { name: 'Internista', slug: 'internistas', active: true },
  { name: 'Angiologo', slug: 'angiologos', active: true },
  { name: 'Neurologo', slug: 'neurologos', active: true },
  { name: 'Homeopata', slug: 'homeopatas', active: true },
  { name: 'Alergologo', slug: 'alergologos', active: true },
  { name: 'Fisioterapeuta', slug: 'fisioterapeutas', active: true },
  { name: 'Laboratorio de Análisis Clínicos', slug: 'laboratorios-de-analisis-clinicos', active: true },
  { name: 'Nefrologo', slug: 'nefrologos', active: true },
  { name: 'Proctologo', slug: 'proctologos', active: true },
  { name: 'Neumologo', slug: 'neumologos', active: true },
  { name: 'Medico Familiar', slug: 'medicos-familiares', active: true },
  { name: 'Spa Terapéutico', slug: 'spa-terapeuticos', active: true },
  { name: 'Farmacia', slug: 'farmacias', active: true },
  { name: 'Audiologo', slug: 'audiologos', active: true },
  { name: 'Masajista', slug: 'masajistas', active: true },
  { name: 'Tienda de Articulos Ortopédicos', slug: 'tiendas-de-articulos-ortopedicos', active: true },
  { name: 'Tienda de Sillas de Ruedas', slug: 'tiendas-de-sillas-de-ruedas', active: true },
  { name: 'Opticas', slug: 'opticas', active: true },
  { name: 'Radiologo', slug: 'radiologos', active: true },
  { name: 'Optometrista', slug: 'optometristas', active: true },
  { name: 'Quiropractico', slug: 'quiropractico', active: true },
  { name: 'Periodoncista', slug: 'periodoncistas', active: true },
  { name: 'Esteticista', slug: 'esteticistas', active: true }
];

// Las 5 ciudades más pobladas con sus estados
const topCities = [
  { city: 'Ciudad de México', state: 'Ciudad de México', citySlug: 'ciudad-de-mexico', stateSlug: 'ciudad-de-mexico' },
  { city: 'Guadalajara', state: 'Jalisco', citySlug: 'guadalajara', stateSlug: 'jalisco' },
  { city: 'Monterrey', state: 'Nuevo León', citySlug: 'monterrey', stateSlug: 'nuevo-leon' },
  { city: 'Puebla', state: 'Puebla', citySlug: 'puebla', stateSlug: 'puebla' },
  { city: 'Tijuana', state: 'Baja California', citySlug: 'tijuana', stateSlug: 'baja-california' },
];

const Specialties = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Helmet>
        <title>Especialidades Médicas | Directorio Médico</title>
        <meta name="description" content="Encuentra especialistas médicos por especialidad" />
      </Helmet>

      <h1 className="text-3xl font-bold mb-8">Especialidades Médicas, Servicios y Profesionales de la Salud</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {specialties.map((specialty) => (
          <div key={specialty.slug} className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">{specialty.name}</h2>
            
            {specialty.active && (
              <div className="space-y-2">
                {/* Top 5 ciudades */}
                {topCities.map((location) => (
                  <div key={location.citySlug}>
                    <Link
                      to={`/${location.stateSlug}/${specialty.slug}-en-${location.citySlug}`}
                      className="text-primary-600 hover:text-primary-700 block"
                    >
                      {specialty.name} en {location.city}
                    </Link>
                  </div>
                ))}
                
                {/* Enlace "ver más" */}
                <Link
                  to={`/especialidades-medicas/en-detalle/${specialty.slug}`}
                  className="text-primary-600 hover:text-primary-700 inline-block mt-4"
                >
                  ver más »
                </Link>
              </div>
            )}
            
            {!specialty.active && (
              <span className="text-gray-400">Próximamente</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Specialties; 